export default __webpack_public_path__ + "static/media/done-tick.94e2ad46.svg";